import Vue from "vue";
import Router from "vue-router";
//import Home from "./views/Home.vue";
import Auth from "@/views/Auth";
import Preloader from "@/views/Preloader";
import CompleteRegister from "@/views/CompleteRegister";
import Layout from "@/layout/Layout";
import DashboardLayout from "@/layout/DashboardLayout";

import HelpLayout from "@/layout/HelpLayout";
import { AmplifyEventBus } from "aws-amplify-vue";

import store from "../store";

const DEFAULT_PAGE_TITLE =
  "PacReport - Inteligencia Empresarial para Compras Públicas";

Vue.use(Router);

const routes = [
  {
    path: `/auth`,
    name: `auth`,
    component: Auth,
    meta: {
      title: `PacReport - Login`,
      transitionName: `slide`
    }
  },
  {
    path: `/preloader`,
    name: `preloader`,
    component: Preloader,
    meta: {
      title: `PacReport - Cargando...`,
      requiresAuth: true,
      transitionName: `slide`
    }
  },
  {
    path: `/complete-register`,
    name: `complete-register`,
    component: CompleteRegister,
    meta: {
      title: `PacReport - Complete el Registro`,
      requiresAuth: true,
      transitionName: `slide`
    }
  },
  {
    path: "/about",
    name: "about",
    meta: { title: `PacReport - Acerca de PacReport`, requiresAuth: true },
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue")
  },
  {
    path: "/suscription",
    name: "suscription",
    meta: { title: `PacReport - Suscripción`, requiresAuth: false },
    component: () =>
      import(
        /* webpackChunkName: "suscription" */ "../views/InfoSuscription.vue"
      )
  },
  {
    path: "/verificacion",
    name: "verificacion",
    meta: { title: `Prexis - Verificados de datos`, requiresAuth: false },
    component: () =>
      import(/* webpackChunkName: "suscription" */ "../views/Verificacion.vue"),
  },
  /*  {
    path: `/`,
    name: `home`,
    meta: { requiresAuth: true, transitionName: `slide` },
    component: Layout,
    redirect: "/dashboard"
  }, */
  /* {
    path: "/dashboard",
    name: "dashboard",
    meta: { requiresAuth: true, transitionName: `slide` },
    component: Layout,
    //redirect: "/robots/adjudicados",
    //redirect: "/complete-register",
    children: [
      {
        path: "/",
        component: DashboardLayout,
        children: [
          {
            path: "report",
            name: "report",
            component: () => import("@/views/dashboard/Dashboard"),
            meta: { requiresAuth: true, transitionName: `slide` }
          }
        ]
      }
    ]
  }, */
  {
    path: "/",
    name: "home",
    meta: {
      title: `PacReport - Cargando...`,
      requiresAuth: true,
      transitionName: `slide`
    },
    component: Layout,
    redirect: "/preloader",
    //redirect: "/complete-register",
    children: [
      {
        path: "dashboard",
        component: DashboardLayout,
        //component: () => import("@/components/Home")
        redirect: "/inicio",
        children: [
          {
            path: "inicio",
            name: "inicio",
            redirect: "pacs",
            component: () => import("@/views/dashboard/Dashboard"),
            meta: {
              title: `PacReport - Dashboard`,
              requiresAuth: true,
              transitionName: `slide`
            }
          },
          {
            path: "entidades",
            name: "entidades",
            component: () => import("@/views/dashboard/Entidades"),
            meta: {
              title: `PacReport - Entidades Contratantes`,
              requiresAuth: true,
              transitionName: `slide`
            }
          },
          {
            path: "proveedores",
            name: "proveedores",
            component: () => import("@/views/dashboard/Proveedores"),
            meta: {
              title: `PacReport - Proveedores`,
              requiresAuth: true,
              transitionName: `slide`
            }
          },
          {
            path: "region",
            name: "region",
            component: () => import("@/views/dashboard/Region"),
            meta: {
              title: `PacReport - Región`,
              requiresAuth: true,
              transitionName: `slide`
            }
          },
          {
            path: "provincias",
            name: "provincias",
            component: () => import("@/views/dashboard/Provincias"),
            meta: {
              title: `PacReport - Provincias`,
              requiresAuth: true,
              transitionName: `slide`
            }
          },
          {
            path: "cantones",
            name: "cantones",
            component: () => import("@/views/dashboard/Cantones"),
            meta: {
              title: `PacReport - Cantones`,
              requiresAuth: true,
              transitionName: `slide`
            }
          },
          {
            path: "cpc5",
            name: "cpc5",
            component: () => import("@/views/dashboard/Cpc5"),
            meta: {
              title: `PacReport - Cpcs Nivel 5`,
              requiresAuth: true,
              transitionName: `slide`
            }
          },
          {
            path: "cpc9",
            name: "cpc9",
            component: () => import("@/views/dashboard/Cpc9"),
            meta: {
              title: `PacReport - Cpcs Nivel 9`,
              requiresAuth: true,
              transitionName: `slide`
            }
          },
          {
            path: "procedimientos",
            name: "procedimientos",
            component: () => import("@/views/dashboard/Procedimientos"),
            meta: {
              title: `PacReport - Procedimientos`,
              requiresAuth: true,
              transitionName: `slide`
            }
          },
          {
            path: "tipos",
            name: "tipos",
            component: () => import("@/views/dashboard/Tipos"),
            meta: {
              title: `PacReport - Tipo de Compra`,
              requiresAuth: true,
              transitionName: `slide`
            }
          },
          {
            path: "regimen",
            name: "regimen",
            component: () => import("@/views/dashboard/Regimen"),
            meta: {
              title: `PacReport - Régimen`,
              requiresAuth: true,
              transitionName: `slide`
            }
          },
          {
            path: "periodos",
            name: "periodos",
            component: () => import("@/views/dashboard/Periodos"),
            meta: {
              title: `PacReport - Periodos`,
              requiresAuth: true,
              transitionName: `slide`
            }
          },
          {
            path: "ventas-publicas",
            name: "ventas-publicas",
            component: () => import("@/views/dashboard/VentasPublicas"),
            meta: {
              title: `PacReport -Reporte de Ventas Públicas`,
              requiresAuth: true,
              transitionName: `slide`
            }
          },
          {
            path: "pacs",
            name: "pacs",
            component: () => import("@/views/dashboard/Pacs"),
            meta: {
              title: `PacReport - Pac Consolidado`,
              requiresAuth: true,
              transitionName: `slide`
            }
          },
          {
            path: "ejecutados",
            name: "ejecutados",
            component: () => import("@/views/dashboard/Ejecutados"),
            meta: {
              title: `PacReport - Ejecutados`,
              requiresAuth: true,
              transitionName: `slide`
            }
          },
          {
            path: "transito",
            name: "transito",
            component: () => import("@/views/dashboard/Transito"),
            meta: {
              title: `PacReport - Items en Transito`,
              requiresAuth: true,
              transitionName: `slide`
            }
          },
          {
            path: "infima",
            name: "infima",
            component: () => import("@/views/dashboard/Infima"),
            meta: {
              title: `PacReport - Necesidades de Contratación y Recepción de Proformas`,
              requiresAuth: true,
              transitionName: `slide`
            }
          }
        ]
      },

      {
        path: "ayuda",
        component: HelpLayout,
        //component: () => import("@/components/Home")
        redirect: "/esp",
        children: [
          {
            path: "esp",
            name: "esp",
            component: () => import("@/views/Help"),
            meta: {
              title: `PacReport - Ayuda`,
              requiresAuth: true,
              transitionName: `slide`
            }
          }
        ]
      }
    ]
  }
];

const router = new Router({
  mode: "history",
  routes
});

AmplifyEventBus.$on("authState", async state => {
  if (state === "signedOut") {
    //console.log("App.vue AmplifyEventBus.$on(authState) state: ", state);
    //console.log("signedOut");
    store.dispatch("setUser", null);
    router.push("/auth");
  } else if (state === "signedIn") {
    //console.log("signedIn");
    router.push("/preloader");
  }
});

router.afterEach(to => {
  Vue.nextTick(() => {
    document.title = to.meta.title || DEFAULT_PAGE_TITLE;
  });
});

router.beforeResolve((to, from, next) => {
  //console.log(`router.beforeResolve((${to.path}, ${from.path}, ${next})`);
  if (to.matched.some(record => record.meta.requiresAuth)) {
    Vue.prototype.$Amplify.Auth.currentAuthenticatedUser()
      .then(data => {
        console.log(data);
        if (data && data.signInUserSession) {
          if (!store.getters.user) {
            Vue.prototype.$Amplify.Auth.currentUserInfo()
              .then(({ attributes }) => {
                //Solo rastreamos cuando ya se han cargado los datos de la empresa
                if (store.getters.empresa) {
                  const userAttributes = {};
                  Object.entries(attributes).forEach(([key, value]) => {
                    userAttributes[key] = [`${value}`];
                  });
                  Vue.prototype.$Amplify.Analytics.updateEndpoint({
                    address: attributes.email, // Or phone_number
                    attributes: {
                      // Custom attributes that your app reports to Amazon Pinpoint. You can use these attributes as selection criteria when you create a segment.
                      razonSocial: [store.getters.empresas[0].label],
                      ruc: [store.getters.empresas[0].value]
                    },
                    channelType: "EMAIL", // Or 'SMS'
                    optOut: "NONE",
                    userId: attributes.sub,
                    userAttributes
                  });
                }
              })
              .then(() => {
                store.dispatch("setUser", data);
              });
          }

          //console.log("to.path", to.path);
          store.dispatch("setRoute", to.path);
        }
        next();
      })
      .catch(e => {
        console.log(e);
        store.dispatch("setUser", null);
        next({
          path: "/auth",
          query: {
            redirect: to.fullPath
          }
        });
      });
  }
  next();
});

export default router;
